import React, { Component } from 'react';
import './JobViews.scss';
import { jobViews } from '../../../config'
import Toggle from 'react-toggle'
import {Link} from 'react-router'
import classNames from 'classnames'

class JobViews extends Component {

    constructor(props) {
        super(props);
        this.state = {
          open: false
        }
        this._openClose = this._openClose.bind(this)
    }

    onChangeCheck (value, check) {
      this.props._filter(value, check)
    }

    _openClose () {
      this.setState({open: !this.state.open})
    }

    componentDidUpdate (prevProps) {
      if (prevProps.view !== this.props.view) {
        this.setState({open: !this.state.open})
      }
    }

    render() {

        const classes = classNames({
          'filters-comp job-views': true,
          'open': this.state.open
        })

        const views = jobViews.map((item, index) => {
          //const activeClass = this.props.activeClass ? this.props.activeClass : 'active'
          const classActive = this.props.view === item.value ? 'active' : ''
          return (
            <Link key={`filter${index}`} className={`${item.class} ${item.value} ${classActive}`} to={`/job/${this.props.jobId}/${item.value}`}>
              <div>
                <i className={item.icon} />
              </div>
              <p>{item.label}<br/><small>{item.text}</small></p>
              <i className="icon-chevron-right pull-right"></i>
            </Link>
          )
        })

        return (
            <div>
              <button className="open-close-mobile btn-block btn-lg btn btn-info visible-xs" onClick={this._openClose}>
                <div className='row'>
                  <div className='col-xs-6 text-left'>
                    OPEN
                  </div>
                  <div className='col-xs-6 text-right'>
                    <i className="icon-chevron-down"></i>
                  </div>
                </div>

              </button>
              <div className={classes}>
                {views}
              </div>
            </div>
        )
    }
}

export default JobViews



// WEBPACK FOOTER //
// ./src/views/components/JobViews/index.js